import { Typography, Box } from "@mui/material";

export default function ProgressOverviewItem({
    customSX,
    title,
    value,
    unit,
    subText,
}) {
    const customStyles = {
        ...customSX,
    };
    return (
        <Box sx={customStyles}>
            <Typography variant="body1" color="textSecondary">
                {title}
            </Typography>

            {value !== null && value !== undefined && value !== 0 ? (
                <Box display={"flex"} alignItems="center">
                    <Typography variant="h6">{value}</Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mt: "4px", ml: "3px" }}
                    >
                        {unit}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mt: "4px", ml: 1 }}
                    >
                        {subText}
                    </Typography>
                </Box>
            ) : (
                <Typography variant="body2">- No Data -</Typography>
            )}
        </Box>
    );
}
